import { gql } from "@apollo/client";

export const GET_PROFESIONALES_RI_BY_ID = gql`
query ProfesionalRIById (
    $idDatosGenerales: Int!
) {
    profesionalRIById (
        idDatosGeneralesRI: $idDatosGenerales
    ){
        profesionalRI{
            idTipoProfesional
        }
        profesionalEspecialidadRI{
            idEspecialidad
        }
    }
}`;